/**
 * Mapa rota -> módulo avaliado pela pesquisa de NPS.
 *
 * A chave é a RAIZ do `route.name` (o trecho antes do primeiro ponto), porque
 * o `router.afterEach` entrega o nome da rota FOLHA: quem está no módulo de
 * comissões chega como `comissoes.fechamentos`, não `comissoes`. Casar pelo
 * nome inteiro faria a maioria dos módulos nunca disparar.
 *
 * O valor é a CHAVE do módulo, gravada na coluna `modulo`. A coluna aceita
 * texto livre, então módulo novo entra só acrescentando a linha aqui e o
 * rótulo correspondente em `PERGUNTAS` (aawz_nps/usecases/usecase_nps.py) —
 * sem migration. Sem o rótulo lá, a pergunta não tem como ser montada e a
 * pesquisa simplesmente não aparece naquela rota.
 *
 * ROTA FORA DO MAPA NÃO DISPARA — a frase é "Que nota você dá para ___?", e um
 * módulo sem nome próprio produziria uma pergunta mal montada.
 *
 * O texto da pergunta vem do SERVIDOR junto da elegibilidade, não daqui: assim
 * o nome com artigo tem uma fonte só, e mudar a frase não exige deploy do front.
 */
export const MODULOS_POR_RAIZ = {
  carteira: 'consolidador',
  resumo: 'consolidador',
  crm: 'crm',
  comissoes: 'comissoes',
  simulador: 'simulador',
  clientes: 'clientes',
  tarefas: 'tarefas',
  tasks: 'tarefas',
  opportunities: 'oportunidades',
  boletador: 'boletador',
  'data-room': 'data_room',
  // A rota se chama `treasury`; "tesouraria" é só o rótulo na navegação.
  treasury: 'tesouraria',
  dashboard: 'bi',
  home: 'plataforma',
}

/**
 * @param {string} nomeDaRota `route.name`, folha ou raiz
 * @returns {string|null} chave do módulo, ou null quando a rota não é avaliada
 */
export function moduloDaRota(nomeDaRota) {
  if (!nomeDaRota) return null
  const raiz = String(nomeDaRota).split('.')[0]
  return MODULOS_POR_RAIZ[raiz] || null
}
